// extracted by mini-css-extract-plugin
export default {"suspendedPage":"kaJC6VXN","content":"_AKFezEv","title":"TO4fLPDN","description":"u2swty20"};